{
    "image_upload_error": "Impossibile caricare l'immagine. Prova a ricaricare questa pagina e selezionare nuovamente un'immagine.",
    "search_placeholder": "Cerca foto e illustrazioni",
    "search": "Trova",
    "photo": "Immagine",
    "image_by": "di",
    "free_photos_from": "Immagini stock gratuite da",
    "uploading": "Caricamento",
    "cancel": "Annulla",
    "select": "Seleziona"
}
